



































































import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";

@Component({
  components: {}
})
export default class App extends Vue {
  get authenticated() {
    return lockModule.sessionId;
  }

  get appError() {
    return lockModule.errorMessage;
  }

  logout() {
    //
    lockModule.logout();
  }
}
